<template>
    <vx-card title="Добавление  ключевого слова для автотегов" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="required">Ключевое слово</label>
                    <vs-textarea v-on:keyup.enter="saveKeywordAdTags()" v-model="form.keyword" :danger="!!errors.name"
                        :danger-text="errors.keyword" autocomplete="off" class="mt-1 w-full required" rows="5" auto-grow="true"
                        placeholder="Несколько ключевых слов вводите через запятую"/>
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="required">Теги</label>
                    <v-select :options="dicts.adTags" label="name" class="w-full" v-model="form.adTagIds" multiple
                        :reduce="(a) => a.id">
                    </v-select>
                </div>
            </div>
        </div>

        <vs-button :disabled="!this.form.keyword || !this.form.adTagIds || this.form.adTagIds.length == 0"
            class="mt-5 mr-2" color="success" @click="saveKeywordAdTags()" type="filled">
            Сохранить
        </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled">
            Отмена
        </vs-button>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';


export default {
    name: 'adTagCatogory-create',
    data() {
        return {
            browser: undefined,
            dicts: {
                adTags: [],
            },
            form: {
                keyword: undefined,
                adTagIds: undefined,
            },
            errors: {
                name: '',
                AdTagCategoryId: ''
            }
        }
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        loadDicts() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios.all([
                this.axios.get('keywordAdTags/dicts'),
            ])
                .then(axios.spread((dicts) => {
                    this.dicts.adTags = dicts.data.adTags;
                }))
                .catch((err) => {
                    this.$vs.notify({
                        title: "Ошибка!",
                        text: "Ошибка загрузки справочников.",
                        color: "danger",
                    });
                })
                .finally(() => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                });
        },
        saveKeywordAdTags() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'POST',
                url: 'keywordAdTags',
                params: this.form,
                errors: this.errors,
                success: (user) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно добавлено",
                        text: "Ключевое слово успешно добавлено",
                        color: "success",
                    });
                    this.$router.push('/content-quality/keyword-ad-tags');
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при добавлении ключевого слова!",
                        color: "danger",
                    });
                }
            })
        },
        cancelEdit() {
            this.$router.push('/content-quality/keyword-ad-tags');
        },
    },
    mounted() {
        this.loadDicts();
    }
}
</script>

<style>
.select-error>div {
    border: 1px solid rgba(var(--vs-danger), 1) !important;
}
</style>